import { Build, Component, h, Host, Prop, State } from '@stencil/core';
import { translate } from '~service/translation-service';

interface BlogTeaserInterface {
  id: number;
  title: string;
  link: string;
  date: string;
  image: string;
}

@Component({
  tag: 'uvex-wp-blog-teaser',
  styleUrl: './wp-blog-teaser.scss',
})
export class WpBlogTeaser {
  @Prop() feed: string;
  @State() items: BlogTeaserInterface[] = [];

  async componentDidLoad() {
    if (!Build.isBrowser) {
      return;
    }

    try {
      const result = await fetch(this.feed).then(res => res.text());
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(result, 'text/xml');
      const items = [];
      Array.from(xmlDoc.querySelectorAll('item')).forEach((value: Element, index: number) => {
        if (index < 3) {
          items.push({
            id: index,
            title: value.querySelectorAll('title')[0].textContent,
            link: value.querySelectorAll('link')[0].textContent,
            date: new Date(value.querySelectorAll('pubDate')[0].textContent).toLocaleDateString('en-US'),
            image: value.querySelectorAll('image')[0].textContent,
          });
        }
      });
      this.items = items;
    } catch (e) {}
  }

  render() {
    return (
      <Host hidden={this.items.length === 0}>
        {this.items.map(item => (
          <div class="wp-blog-teaser">
            <div class="wp-blog-teaser-date">{item.date}</div>
            <div class="wp-blog-teaser-image embed-responsive embed-responsive-3by2">
              <img src={item.image} width="300" height="200" loading="lazy" decoding="async" class="embed-responsive-item" />
            </div>
            <h3>{item.title}</h3>
            <p>
              <a class="link-full btn" target="_blank" rel="noreferrer noopener" href={item.link}>
                {translate('more')}
              </a>
            </p>
          </div>
        ))}
      </Host>
    );
  }
}
